import Vue from 'vue';
import VueRouter from 'vue-router';

import navbar from '../components/navbar/navbar';
import footer from '../components/footer/footer';
import generalPage from '../components/pages/general';


Vue.use(VueRouter);

const [routerPush, routerReplace] = [VueRouter.prototype.push, VueRouter.prototype.replace];

VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error);
};

VueRouter.prototype.replace = function replace(location) {
    return routerReplace.call(this, location).catch(error => error);
};

const vueRouter = new VueRouter({
    routes: [{
        path: '/',
        components: {
            navbar: navbar,
            footer: footer,
            default: generalPage
        }
    }]
});


export default vueRouter;